/**
 * Read More — collapses .letter-more and inserts the toggle.
 *
 * Progressive enhancement, same shape as the funders dropdown: the markup ships
 * with the full letter visible and no button. Only if JS runs does the tail get
 * collapsed, so nothing is ever unreachable when it doesn't.
 */

export default function readMore(): void {
  document.querySelectorAll<HTMLElement>('.letter-more').forEach((more, i) => {
    const id = more.id || `letter-more-${i + 1}`;
    more.id = id;
    more.hidden = true;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'read-more';
    button.textContent = 'Read More';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', id);

    button.addEventListener('click', () => {
      const open = more.hidden;
      more.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Read Less' : 'Read More';
      // collapsing from below the fold would leave the reader stranded
      if (!open) button.scrollIntoView({ block: 'nearest' });
    });

    more.after(button);
  });
}
